import { StepData } from '@/lib/Steppers';
import { CreateDestinationStep } from './types';

export const CREATE_DESTINATION_STEPS: ReadonlyArray<StepData<CreateDestinationStep>> = [
  {
    id: 'selectAudienceAndDestination',
    title: 'ALL:destinations.steps.selectAudienceAndDestination.title',
  },
  {
    id: 'selectProperties',
    title: 'ALL:destinations.steps.selectProperties.title',
  },
  {
    id: 'sync',
    title: 'ALL:destinations.steps.sync.title',
  },
] as const;
